import {styled} from "@mui/material/styles";
import {Divider} from "@mui/material";
import {grey} from "../assets/colors";

export const FortressDivider = styled(Divider)({
    fontSize: '0.8rem',
    color: grey
});

